import type { AxiosResponse } from 'axios';
import React from 'react';

import { SvLocalisationService } from '../../services/SvLocalisationService';
import XDDropdownItem from './XDDropdownItem';

interface Props {
  type: 'frontend' | 'backend' | 'homepage';
  children: React.ReactNode;
}

export default function XDDropdownItemDownload(props: Props) {
  const onClick = async () => {
    const response = await SvLocalisationService.downloadI18nFile({ type: props.type });

    const blob = response.getBlob();
    if (!blob) {
      throw new Error(await response.getMessage());
    }

    const blobUrl = window.URL.createObjectURL(blob);

    let filename = 'language.json';
    const headers = (response.axiosResponseOrError as AxiosResponse).headers;
    const contentDisposition = headers?.['content-disposition'] as string | undefined;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch?.[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 100);
  };

  return <XDDropdownItem onClick={onClick}>{props.children}</XDDropdownItem>;
}
